export default __webpack_public_path__ + "static/media/Group 883486.91c86d4b.svg";